export default "__VITE_ASSET__qoNEt422__"